import { Fragment } from 'react';
import useCaro from '~/hooks/useCaro';
import { ReactSVG } from 'react-svg';

/**
 * Episodes Carousel
 * @category Component
 * @extends Component
 * @summary Displays the schedule carousel block.
 * @prop {Object} schedule - The schedule items.
 * @prop {Object} current - The current schedule item.
 * @prop {string} title - The block title.
 * @prop {string} range - The date range.
 * @prop {func} setEpisode - Function to set episode.
 * @return {Node} React node containing the schedule carousel.
 */

const CarouselContent = (props) => {
  const { title, schedule, current, setEpisode, range } = props;
  const { viewportRef, scrollNext, scrollPrev, selectedIndex } = useCaro({
    loop: false,
    align: 'start'
  });

  return (
    <div className='x-hidden'>
      <div className='carousel-episode'>
        <div className='constrain'>
          <h2 className='carousel-episode__heading'>
            { title }
          </h2>
          <h3 className='carousel-episode__subheading'>
            { range }
          </h3>
          <div className='carousel-episode__viewport' ref={viewportRef}>
            <div className='carousel-episode__container'>
              {schedule.map((item, i) => (
                <Fragment key={`content-item-${i}`}>
                  { item &&
                    <button
                      type='button'
                      className={ `card ${ item?.field_display_date === current?.field_display_date ? 'carousel-episode__active'  : null}` }
                      onClick={ setEpisode }
                      data-day={ item?.day }
                    >
                      <img
                        src={ item?.field_image?.field_image?.lg?.url }
                        width={ item?.field_image?.field_image?.lg?.width }
                        height={ item?.field_image?.field_image?.lg?.height }
                        alt={ item?.field_image?.alt }
                        className='card__img'
                        loading='lazy'
                      />
                      <h3>
                        { item?.label }
                      </h3>
                    </button>
                  }
                </Fragment>
              ))}
            </div>
          </div>
          { selectedIndex !== 0 &&
            <button className='carousel-episode__arrow carousel-episode__arrow--prev' type='button' onClick={ scrollPrev } aria-label='Previous Slide'>
              <ReactSVG src='/img/icons/arrow-hollow_left.svg' />
            </button>
          }
          { selectedIndex < schedule.length - 2 &&
            <button className='carousel-episode__arrow carousel-episode__arrow--next' type='button' onClick={ scrollNext } aria-label='Next Slide'>
              <ReactSVG src='/img/icons/arrow-hollow_left.svg' />
            </button>
          }
        </div>
      </div>
    </div>
  );
}

export default CarouselContent;
